import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { SettingsPage } from "@/components/Pages/Settings";

const settingsSearchSchema = z.object({
  tab: z
    .enum(["general", "team", "shipping", "socials", "instagram", "billing", "danger"])
    .optional(),
});

export const Route = createFileRoute("/_guard/settings/")({
  validateSearch: settingsSearchSchema,
  component: function SettingsRoute() {
    const { tab } = Route.useSearch();
    return <SettingsPage key={tab ?? "default"} initialTab={tab} />;
  },
});
